__turbopack_context__.v({
  "fieldset": "_2G_C7G_fieldset",
  "fieldset__asterisk": "_2G_C7G_fieldset__asterisk",
  "fieldset__inner": "_2G_C7G_fieldset__inner",
  "fieldset__legend": "_2G_C7G_fieldset__legend",
});
